import { Checkbox, FormControl, FormControlLabel, InputLabel, MenuItem, Select } from '@mui/material';
import React, { useState } from 'react';

const DifferenceSelection = ({ mergeAttributes, selectedAttribute, setSelectedAttribute }) => {
    const [focused, setFocused] = useState(false);

    const handleFocusBlur = (isFocused) => {
        setFocused(isFocused);
    }
    const handleSelect = (attribute) => {
        setSelectedAttribute(attribute)
    }

    return <>
        <FormControl fullWidth>
            <InputLabel id="select-merge-attributes">
                {focused ? 'Attributes': 'Select merge attributes'}
            </InputLabel>
            <Select
                labelId="select-merge-attributes"
                id="select-merge-attributes"
                value={selectedAttribute}
                label="Config"
                onChange={(e) => handleSelect(e.target.value)}
                onFocus={(e) => handleFocusBlur(true)}
                onBlur={(e) => handleFocusBlur(false)}
            >    
                {mergeAttributes?.map((attribute)=> (
                    <MenuItem value={attribute} key={attribute}>
                        {attribute}
                    </MenuItem>
                ))}  
                
            </Select>
        </FormControl>
    </>
}
export default DifferenceSelection;